import * as React from "react";

function SvgChecklistIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={20}
      height={18}
      {...props}
    >
      <defs>
        <path
          d="M1.44 3.75c.79 0 1.43-.65 1.43-1.44 0-.79-.64-1.44-1.43-1.44a1.44 1.44 0 000 2.88"
          id="checklist-icon_svg__a"
        />
        <path
          d="M1.44 16.76c.79 0 1.43-.65 1.43-1.44 0-.79-.64-1.44-1.43-1.44a1.44 1.44 0 000 2.88"
          id="checklist-icon_svg__b"
        />
        <path
          d="M1.44 10.25c.79 0 1.43-.64 1.43-1.43a1.434 1.434 0 10-1.43 1.43"
          id="checklist-icon_svg__c"
        />
        <path
          d="M20.11 3.17H5.75V1.45h14.36v1.72z"
          id="checklist-icon_svg__d"
        />
        <path
          d="M20.11 16.18H5.75v-1.72h14.36v1.72z"
          id="checklist-icon_svg__e"
        />
        <path
          d="M17.24 9.68H5.75V7.95h11.49v1.73z"
          id="checklist-icon_svg__f"
        />
      </defs>
      <use xlinkHref="#checklist-icon_svg__a" fill="#dedede" />
      <use
        xlinkHref="#checklist-icon_svg__a"
        fillOpacity={0}
        stroke="#000"
        strokeOpacity={0}
      />
      <use xlinkHref="#checklist-icon_svg__b" fill="#dedede" />
      <use
        xlinkHref="#checklist-icon_svg__b"
        fillOpacity={0}
        stroke="#000"
        strokeOpacity={0}
      />
      <use xlinkHref="#checklist-icon_svg__c" fill="#dedede" />
      <use
        xlinkHref="#checklist-icon_svg__c"
        fillOpacity={0}
        stroke="#000"
        strokeOpacity={0}
      />
      <g>
        <use xlinkHref="#checklist-icon_svg__d" fill="#dedede" />
        <use
          xlinkHref="#checklist-icon_svg__d"
          fillOpacity={0}
          stroke="#000"
          strokeOpacity={0}
        />
      </g>
      <g>
        <use xlinkHref="#checklist-icon_svg__e" fill="#dedede" />
        <use
          xlinkHref="#checklist-icon_svg__e"
          fillOpacity={0}
          stroke="#000"
          strokeOpacity={0}
        />
      </g>
      <g>
        <use xlinkHref="#checklist-icon_svg__f" fill="#dedede" />
        <use
          xlinkHref="#checklist-icon_svg__f"
          fillOpacity={0}
          stroke="#000"
          strokeOpacity={0}
        />
      </g>
    </svg>
  );
}

export default SvgChecklistIcon;
